import React, { useState } from 'react'
import * as yup from 'yup'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import DeleteIcon from '@mui/icons-material/Delete'

import { BoldFormTitle } from '../styles/Text'
import { FlexEndContainer, PaddedForm, StyledDialog, StyledDialogContent } from '../styles/Containers'
import { ErrorMessage } from '../common/UserMessage'
import Button, { IconButton, SecondaryButton } from '../common/Button'
import axios from '../../dataClient/dataClient'
import ArchiveFileForm from './ArchiveFileForm'

const FormTitle = styled(BoldFormTitle)`
  text-transform: none;
`

const archiveSchema = yup.object().shape({
  reason: yup.string().required('Reason is required')
})

function ArchiveFileButton({ fileId, name, onSuccess = () => {}, disabled = false }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const methods = useForm({ resolver: yupResolver(archiveSchema) })
  const { handleSubmit, reset } = methods

  const handleOpen = () => setIsVisible(true)
  const handleClose = () => {
    setIsVisible(false)
    reset({ reason: '' })
    setError(false)
    setIsLoading(false)
  }

  const onError = (errors, e) => console.error('Error', errors, e)

  async function onSubmit(data) {
    setIsLoading(true)
    setError(false)

    axios
      .post(`/file/${fileId}/archive`, { reason: data.reason })
      .then(() => {
        handleClose()
        onSuccess()
      })
      .catch(e => {
        console.error('Failed archiving file', fileId, e)
        setError(true)
        setIsLoading(false)
      })
  }

  return (
    <>
      <IconButton aria-label="Remove File" disabled={disabled} onClick={handleOpen}>
        <DeleteIcon />
      </IconButton>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false}>
        <StyledDialogContent>
          <FormProvider {...methods}>
            <PaddedForm onSubmit={handleSubmit(onSubmit, onError)}>
              <FormTitle>Remove File: {name}</FormTitle>
              <ArchiveFileForm loading={isLoading} />
              {error && <ErrorMessage>There was an error removing the file. Please try again.</ErrorMessage>}
              <FlexEndContainer>
                <SecondaryButton onClick={handleClose} disabled={isLoading}>
                  Cancel
                </SecondaryButton>
                <Button type="submit" loading={isLoading}>
                  Confirm
                </Button>
              </FlexEndContainer>
            </PaddedForm>
          </FormProvider>
        </StyledDialogContent>
      </StyledDialog>
    </>
  )
}

ArchiveFileButton.propTypes = {
  fileId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  disabled: PropTypes.bool
}

export default ArchiveFileButton
